export const QUERY_COST_CURRENCY = "USD";
export const QUERY_COST_THRESHOLD = 0.5; // USD
